import React from 'react';
// @ts-ignore
import LinkedAccountProviderOauthConfigForm from './LinkedAccountProviderOauthConfigForm';

import './styles/ContentSourceProviderPage.scss';

type Props = {
  params: {
    uuid: string;
  };
};

class OauthConfigPage extends React.Component<Props, {}> {
  render() {
    return (
      <div className="ContentSourceProviderPage">
        <div className="ContentSourceProviderPage-form">
          <LinkedAccountProviderOauthConfigForm uuid={this.props.params.uuid} />
        </div>
      </div>
    );
  }
}

export default OauthConfigPage;
